// Staff avatar. When `staff.profilePicKey` is set we render the uploaded
// image from /staff/:id/profile-pic; otherwise fall back to a monogram with
// a hash-derived color so 12+ staff stay visually distinguishable.
// Palette is functional data-viz (per-person identity), not chrome — so it
// intentionally exceeds DESIGN.md's tan+cream palette.

import { useState } from 'react';
import { profilePicUrl } from '../lib/api.ts';

const PALETTE = [
  '#bda793', // tan
  '#9c8574', // tan hover
  '#3d8b5e', // green
  '#1c398e', // blue
  '#874b00', // amber
  '#6e11b0', // purple (functional, not chrome)
  '#dd3327', // red
  '#525252'  // gray
];

function avatarColor(id) {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export const Avatar = ({ staff: s, large = false }) => {
  // `imgFailed` covers the race where profilePicKey is stale or the R2
  // object is missing — falling back to the monogram keeps the UI from
  // showing a broken-image icon.
  const [imgFailed, setImgFailed] = useState(false);
  if (!s) return <span className={`avatar avatar-unknown${large ? ' avatar-lg' : ''}`}>?</span>;
  const hasPic = !!s.profilePicKey && !imgFailed;
  const initial = /[A-Za-z]/.test(s.name[0]) ? s.name[0].toUpperCase() : s.name[0];
  const cls = `avatar${large ? ' avatar-lg' : ''}${hasPic ? ' avatar-pic' : ''}`;
  if (hasPic) {
    return (
      <span className={cls} title={`${s.name} · ${s.title || ''}`}>
        <img src={profilePicUrl(s.id, s.profilePicKey)} alt={s.name}
             onError={() => setImgFailed(true)} />
      </span>
    );
  }
  return (
    <span className={cls} title={`${s.name} · ${s.title || ''}`}
          style={{ background: avatarColor(s.id) }}>
      {initial}
    </span>
  );
};
